import { useEffect, useState } from 'react';
import { isUndefined, omit } from '../../utils';
import { MergedPurchaseMotionProps } from '../../_core/purchaseMotions/PurchaseMotionPropsInterface';
import { purchaseMotionButtons, purchaseMotionButtonPropsInterface } from '../../_core/common/constants/purchaseMotions';
import { UPGRADE_POINT_LOCATIONS } from '../../_core/common/constants/PurchaseMotionLocations';
import { getCanViewNewSeats } from '../common/eligibility/getCanViewNewSeats';
import { mapPurchaseMotionApiName } from '../../ums/utils';
import { jsx as _jsx } from "react/jsx-runtime";
const PurchaseMotionButton = props => {
  const {
    upgradeData,
    trackingSource,
    purchaseMotions = [],
    level,
    passthroughProps = {},
    overrides = {},
    location
  } = props;
  const purchaseMotion = purchaseMotions[level - 1];
  const isUpgradePoint = location && UPGRADE_POINT_LOCATIONS.includes(location);
  const mappedButtonPassthroughProps = passthroughProps[purchaseMotion] || {};
  const mappedButtonPropsInterface = purchaseMotionButtonPropsInterface[purchaseMotion];
  const MappedButtonComponent = overrides[purchaseMotion] || purchaseMotionButtons[purchaseMotion];
  const [canViewNewSeats, setCanViewNewSeats] = useState(undefined);
  useEffect(() => {
    getCanViewNewSeats().then(res => {
      setCanViewNewSeats(res);
      upgradeData.apiName = mapPurchaseMotionApiName(res, upgradeData.upgradeProduct, 'purchaseMotion', upgradeData.apiName);
    }).catch(() => {
      setCanViewNewSeats(false);
    });
  }, [props, upgradeData]);
  if (isUndefined(MappedButtonComponent) || isUndefined(mappedButtonPropsInterface)) {
    return null;
  }
  const propsToKeep = [...Object.keys(mappedButtonPropsInterface), 'upgradeData', 'use', 'children', 'className', 'disabled'];

  // Exclude the PurchaseMotionButton parent props and non-related props from
  // other types of purchase motions
  const propsToOmit = ['purchaseMotions', 'level', 'overrides', 'passthroughProps', 'isUpgradePoint', ...Object.keys(omit(MergedPurchaseMotionProps, propsToKeep))];
  const propsToPass = omit(props, propsToOmit);
  // propsToPass needs to get the result from getCanViewNewSeats
  propsToPass.canViewNewSeats = canViewNewSeats;
  return /*#__PURE__*/_jsx(MappedButtonComponent, Object.assign({
    "data-selenium-id": `${trackingSource}-${props.upgradeData.apiName}-${purchaseMotion}-button`,
    truncate: true,
    isUpgradePoint: isUpgradePoint,
    level: level,
    canViewNewSeats: canViewNewSeats
  }, mappedButtonPassthroughProps, propsToPass));
};
export default PurchaseMotionButton;